import React from 'react';
import styled from 'styled-components';

interface JoinTeamButtonProps {
  className?: string;
  onClick?: () => void;
}

const Button = styled.button`
  display: inline-block;
  background-color: transparent;
  color: #333;
  border: 1px solid #333;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #333;
    color: white;
  }
`;

/**
 * A reusable button component for triggering the Join Team modal
 * This component delegates the modal handling to the parent App component
 */
const JoinTeamButton: React.FC<JoinTeamButtonProps> = ({ className, onClick }) => {
  return (
    <Button className={className} onClick={onClick}>
      Join our team
    </Button>
  );
};

export default JoinTeamButton; 